import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from 'src/app/Service/axios';

declare let $: any;

@Component({

  selector: 'app-chart-access-determine',

  templateUrl: './chart-access-determine.component.html',

  styleUrls: ['./chart-access-determine.component.css']

})

export class ChartAccessDetermineComponent implements OnInit {

  list_StrChart: any = [];

  list_SystemAbility: any = [];

  selectedNode: any = {};

  mdl_Search: FormGroup = this._formBuilder.group({

    iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

    strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

  })

  constructor(

    private _toolTip: NotificationService,

    private _formBuilder: FormBuilder,

    private _gurd: GurdServiceService,

    private _other: OtherService,

    private _route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this.initialChart();


  }

  async initialChart() {

    this._other.Showspinner();

    let response = await axios.post(`UserManager_Chart_List`, this._other.stringNumberToNumber(this.mdl_Search.value));

    let res = JSON.parse(response.data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._toolTip.showError(res.strError)

    $("#jstree").jstree("destroy");

    $('#jstree').on("changed.jstree", (e: any, data: any) => {

      this.treeOperation(data.instance.get_node(data.selected[0]));

    });

    this.list_StrChart = res;

    this.mapDataToTreeStructure(res, '0');


  }

  async treeOperation(node: any) {

    this.selectedNode = {

      strChart: node.id,

      strComment: node.text,

      iSystemUser: this._gurd.decrypt(localStorage.getItem('ID')!),

      strSession: this._gurd.decrypt(localStorage.getItem('Session')!),

    }

    this._other.Showspinner();

    let response = await axios.post(`UserManager_SystemAbility_List`, this._other.stringNumberToNumber(this.selectedNode));

    let res = JSON.parse(response.data);

    this._other.nonespinner();

    this.list_SystemAbility = res;

    this.mapData4SystemAbility(res)

  }

  mapData4SystemAbility(res: any) {

    let nodeById = new Map();

    let rootNodes: any = [];

    res.forEach((node: any) => {

      node.children = []; // define children property for each node

      nodeById.set(node.strSystemAbility.trim(), node); // collect nodes by their strSystemAbility

    });

    res.forEach((node: any) => {

      let parentNode = nodeById.get(node.strParentCode.trim());

      if (parentNode) parentNode.children.push(node);

      else rootNodes.push(node); // if no parent is found, then it's a root node.

    });

    let convertToTreeData = (nodes: any) => {

      return nodes.map((node: any) => {

        let children = convertToTreeData(node.children);

        return {

          text: node.strComment,

          id: node.strChart,

          children: children.length ? children : null,

          state: { "opened": true, "selected": node.bHas == 0 ? false : true, "disabled": false },


        };

      });

    };

    let treeData = convertToTreeData(rootNodes);

    $("#jstree_Ability").jstree("destroy");

    $('#jstree_Ability').jstree({

      core: {

        "themes": { "stripes": true },

        'data': treeData

      },

      checkbox: {

        three_state: false, // to avoid that fact that checking a node also check others

        whole_node: true,  // to avoid checking the box just clicking the node 

        tie_selection: true // for checking without selecting and selecting without checking

      },

      "plugins": ["wholerow", "checkbox"]

    })

  }

  mapDataToTreeStructure(res: any, target: any) {

    let nodeById = new Map();

    let rootNodes: any = [];

    res.forEach((node: any) => {

      node.children = []; // define children property for each node

      nodeById.set(node.strChart, node); // collect nodes by their Ids

    });

    res.forEach((node: any) => {

      let parentNode = nodeById.get(node.strParentCode);

      if (parentNode) parentNode.children.push(node);

      else rootNodes.push(node); // if no parent is found, then it's a root node.

    });

    //  to sort nodes by iSort

    const sortChildrenByISort = (obj: any) => {

      if (Array.isArray(obj.children) && obj.children.length > 0) {

        obj.children.sort((a: any, b: any) => a.iSort - b.iSort);

        obj.children.forEach(sortChildrenByISort);

      }

    };

    // Sort the rootNodes and their children

    rootNodes.sort((a: any, b: any) => a.iSort - b.iSort);

    rootNodes.forEach(sortChildrenByISort);

    let convertToTreeData = (nodes: any) => {

      return nodes.map((node: any) => {

        let children = convertToTreeData(node.children);

        return {

          text: node.strComment,

          id: node.strChart,

          icon: children.length ? null : "jstree-file",   // icon added only for leaf nodes

          children: children.length ? children : null,

          state: node.strChart == target ? { "opened": true, "selected": false, "disabled": false } : { "opened": false },


        };

      });

    };

    let treeData = convertToTreeData(rootNodes);

    $('#jstree').jstree({

      core: {

        "themes": { "stripes": true },

        'data': treeData

      }

    });

  }

  selectedAbility(event: any) {

    if (event.target.innerText == '') return this._toolTip.showError('لطفا روی نام دسترسی کلیک کنید')

    setTimeout(async () => {

      var selectedAbility = this.list_SystemAbility.filter((a: any) => { return a.strComment.trim() == event.target.innerText })[0];

      selectedAbility.strChart = this.selectedNode.strChart

      selectedAbility.iSystemUser = this._gurd.decrypt(localStorage.getItem('ID')!);

      selectedAbility.strSession = this._gurd.decrypt(localStorage.getItem('Session')!);

      this._other.Showspinner();

      let response = await axios.post(`UserManager_SystemAbility_AddorRemove`, this._other.stringNumberToNumber(selectedAbility));

      let res = JSON.parse(response.data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._toolTip.showError(res.strError);

      else this._toolTip.showSuccess('عملیات با موفقیت انجام شد')


    }, 100);

  }


}
